import React, { ReactElement } from 'react'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import TopicItem, { TopicItemProps } from './TopicItem'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    margin: theme.spacing(0, -1, 3),
    padding: theme.spacing(1, 2),
    '@media print': {
      border: 'none',
      boxShadow: 'none'
    }
  }
}))

export interface ContentProps {
  topics: TopicItemProps[]
}

function Content({ topics }: ContentProps): ReactElement {
  const classes = useStyles()
  return (
    <Paper className={classes.root}>
      {topics.map(item => (
        <TopicItem key={item.topicId} {...item} />
      ))}
    </Paper>
  )
}

export default Content
